import {
defineCustomElement,
MediaMenuButtonElement
} from "vidstack/elements";

defineCustomElement(MediaMenuButtonElement);